import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import { AirportShuttle, FactCheck, LinkOff, LocationOn, MultipleStop, SvgIconComponent, SyncAlt } from '@mui/icons-material';
import { ReactNode } from 'react';
import Vehicles from '../pages/manage/vehicles';
import Vin from '../pages/manage/vin';
import Transfer from '../pages/manage/transfer';
import Destinations from '../pages/manage/destinations/destinations';
import VehicleTypes from '../pages/settings/vehicle_types/vehicleTypes';
import TryVin from '../pages/settings/vehicle_types/tryVin';
import { Inspections } from '../pages/manage/inspections';

export type SidebarTitle = {
  title: string;
  content: ReactNode;
  icon: SvgIconComponent;
  hide?: boolean;
  allowedUserIds?: readonly string[];
};

export type SidebarCategory = {
  categoryId: string;
  category: string;
  titles: SidebarTitle[];
};

export const DEFAULT_MANAGE_PATH = '/manage/manage_vehicles';
export const DEFAULT_SETTINGS_PATH = '/settings/vehicle_types';

export const manageSidebarContent: SidebarCategory[] = [
  {
    categoryId: 'manage',
    category: '',
    titles: [
      { title: 'Vehicles', content: <Vehicles />, icon: DirectionsCarIcon },
      { title: 'Unmatched VINs', content: <Vin />, icon: CarCrashIcon },
      { title: 'Transfer log', content: <Transfer />, icon: SyncAlt },
      { title: 'Destinations', content: <Destinations />, icon: LocationOn },
      { title: 'Inspections', content: <Inspections />, icon: FactCheck },
    ],
  },
];

export const settingsSidebarContent: SidebarCategory[] = [
  {
    categoryId: 'settings',
    category: '',
    titles: [
      { title: 'Vehicle types', content: <VehicleTypes />, icon: DirectionsCarIcon },
      { title: 'Try VIN', content: <TryVin />, icon: DirectionsCarIcon },
    ],
  },
];

export function findSelectionForPath(
  option: string | undefined,
  content: SidebarCategory[]
): [number, number] | null {
  if (!option) {
    return [0, 0];
  }

  const [category, title] = option.replace('-', ' ').split('_');

  const catIndex = content.findIndex(x =>
    category.includes(x.categoryId.toLowerCase())
  );

  if (catIndex >= 0) {
    const titleIndex = content[catIndex].titles.findIndex(x =>
      title?.includes(x.title.toLowerCase())
    );

    if (titleIndex >= 0) {
      return [catIndex, titleIndex];
    }
  }

  for (let i = 0; i < content.length; i++) {
    const titleIndex = content[i].titles.findIndex((item) => {
      const slug = item.title.toLowerCase();
      return option === slug.replace(/ /g, '_') || option === slug.replace(/ /g, '-');
    });

    if (titleIndex >= 0) {
      return [i, titleIndex];
    }
  }

  return null;
}

export function buildManagePath(selection: [number, number]): string {
  const category = manageSidebarContent[selection[0]];
  const title = category.titles[selection[1]].title.replace(' ', '-').toLowerCase();
  return `/manage/${category.categoryId.toLowerCase()}_${title}`;
}

export function buildSettingsPath(selection: [number, number]): string {
  const category = settingsSidebarContent[selection[0]];
  const title = category.titles[selection[1]].title.replace(/ /g, '_').toLowerCase();
  return `/settings/${title}`;
}
